import {VueMasonryPlugin} from './src/VueMasonry.vue'

export default VueMasonryPlugin

export { VueMasonryPlugin }



//////////////////
// WEBPACK FOOTER
// ./~/vue-masonry/index.js
// module id = 71
// module chunks = 4